import api from 'api';

export const loadOwners = api('GET /api/api-integrations/filters/owners');

export const loadPartnerCompanies = api(
  'GET /api/api-integrations/filters/partner-companies'
);

export const loadNetworks = api('GET /api/api-integrations/filters/networks');

export const loadLastUpdatedBy = api(
  'GET /api/api-integrations/filters/last-updated-by'
);
